import type { ComponentTheme } from '../types/component-theme';

export default {
    slots: {
        root: 'mt-6 space-y-6 text-sm leading-relaxed text-(--text-muted)',
        section: 'space-y-3',
        heading: 'font-semibold text-(--text-dark)',
        list: 'list-disc space-y-2 pl-5',
        details: 'rounded-lg border border-(--slate-alpha-20) p-4',
        summary:
            'w-full cursor-pointer gap-2 p-0 text-left text-(--text-dark) hover:bg-transparent active:bg-transparent ' +
            'focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-(--accent-solid)',
        chevron: 'inline-flex shrink-0',
        drawer: 'overflow-hidden',
        drawerContent: 'overflow-hidden',
        content: 'mt-3 space-y-3',
        factors: 'grid grid-cols-3 gap-3 [&_dd]:font-semibold [&_dd]:text-(--text-dark)'
    }
} satisfies ComponentTheme;
